import React, { Component } from 'react';
import cn from 'classnames';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import Icon from '~/components/icon/icon';

class LotList extends Component {
  state = {
    visible: false
  };

  toggleVisible = () => {
    this.setState({
      visible: !this.state.visible
    });
  };

  renderToggle = () => {
    const rotateClass = this.state.visible ? 'rotate-90' : 'rotate-270';
    return <Icon className={`absolute right-0 icon-sm ${rotateClass}`} icon="chevron-left" />;
  };

  render() {
    const { className, lots, title, render } = this.props;

    return (
      <div className={cn(className, 'relative')}>
        <h3 className="f3 mt0 flex items-center pointer" onClick={this.toggleVisible}>
          {title} <em className="f5">({lots.length})</em>
          {this.renderToggle()}
        </h3>
        {this.state.visible && render({ lots })}
      </div>
    );
  }
}

const ProductLotsCard = ({ className, id, query, title, queryKey, render }) => (
  <Query query={query} variables={{ id }} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return (
          <div className="flex justify-center">
            <Spinner className="stroke-brand-red" />
          </div>
        );
      }

      if (error) {
        return <Alert color="danger">Sorry, there was an error getting the lots</Alert>;
      }

      const lots = data.product[queryKey];
      return <LotList lots={lots} title={title} className={className} render={render} />;
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(ProductLotsCard);



// WEBPACK FOOTER //
// ./src/containers/productLotsCard/productLotsCard.jsx